import axios from 'axios'
import toastr from 'toastr'

import Logger from '@Utils/Logger'

export type TOdubPool = 'voice_design' | 'enhancement'

export interface IOdubPoolStatusResponseBody {
  readonly running: boolean
}

export default function fetchOdubPoolStatus(workspaceId: number, pool: TOdubPool) {
  return axios.get<IOdubPoolStatusResponseBody>('/api/v1/odub/pool_status', {
    params: { workspace_id: workspaceId, pool }
  })
}

interface IWarnIfOdubPoolStoppedOptions {
  readonly workspaceId: number
  readonly pool: TOdubPool
  readonly message: string
  readonly title: string
  readonly errorContext: string
}

export async function warnIfOdubPoolStopped(options: IWarnIfOdubPoolStoppedOptions): Promise<void> {
  try {
    const response = await fetchOdubPoolStatus(options.workspaceId, options.pool)
    if (!response.data.running) {
      toastr.info(options.message, options.title)
    }
  } catch (error) {
    Logger.error(error, options.errorContext)
  }
}
